import React from 'react';

import {useDeviceSize, DeviceSize} from '../../../shared/theme/helpers';
import {Platform, View} from 'react-native';
import {LogoSVG, Logo as LogoPng} from '../../../assets/images';
import {useStyles} from '../../../shared/hooks/styles';
import {Image} from '../../../shared/components/image';

export const Logo = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles(() => {
    return {
      imageContainer: {
        width: deviceSize === DeviceSize.desktop ? 173 : 130,
        height: deviceSize === DeviceSize.desktop ? 147 : 105,
      },
    };
  });

  const imageSizes = {
    width: deviceSize === DeviceSize.desktop ? 173 : 130,
    height: deviceSize === DeviceSize.desktop ? 147 : 105,
  };

  return (
    <View style={styles.imageContainer}>
      <Image
        source={(Platform.OS === 'web' ? LogoSVG : LogoPng) as any}
        height={imageSizes.height}
        width={imageSizes.width}
        style={{width: imageSizes.width, height: imageSizes.height}}
      />
    </View>
  );
};
